// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__v8yfQ","list":"BalanceDue_list__3CUsR","listRow":"BalanceDue_listRow__164i2","total":"BalanceDue_total__1nH6C"};